import { Loader2 } from 'lucide-react'
import { useQueryState } from 'nuqs'
import { useEffect } from 'react'
import { useNavigate } from 'react-router'
import useSWR from 'swr'

import { Button } from '@/components/ui/button'
import { apiFetcher } from '@/data/fetcher'
import { AuthCard } from '@/layouts/AuthLayout'
import { ErrorLayout } from '@/layouts/ErrorLayout'
import { formatDate } from '@/lib/formats/formatDate'
import { formatTime } from '@/lib/formats/formatTime'

export default function MaintenancePage() {
  const navigate = useNavigate()
  const [ref] = useQueryState('ref')

  const { data, mutate, isValidating } = useSWR<{
    maintenance: boolean
    until: string | null
  }>('/api/app-status', apiFetcher, { refreshInterval: 30000 })

  useEffect(() => {
    if (data?.maintenance === false) {
      navigate(ref || '/')
    }
  }, [data]) // eslint-disable-line react-hooks/exhaustive-deps

  const until = data?.until ? new Date(data.until) : null

  return (
    <ErrorLayout>
      <title>Probíhá údržba</title>
      <AuthCard
        title="Probíhá údržba"
        description={
          until
            ? `Systém je dočasně nedostupný, nejméně do ${formatDate(until)} ${formatTime(until)}. Vaše data jsou v pořádku.`
            : 'Systém je dočasně nedostupný. Vaše data jsou v pořádku, zkuste to prosím za chvíli.'
        }
      >
        <Button variant="outline" className="w-full" disabled={isValidating} onClick={() => mutate()}>
          {isValidating && <Loader2 className="animate-spin" />}
          Zkusit znovu
        </Button>
        <p className="mt-3 text-center text-xs text-muted-foreground">Stránku kontrolujeme automaticky každých 30 sekund.</p>
      </AuthCard>
    </ErrorLayout>
  )
}
